module.exports = __webpack_public_path__ + "static/media/Figtree-Bold.7f60bbd8.otf";